import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const ClipboardDocumentListIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="solid/clipboard-document-list"><g id="Icon"><path fillRule="evenodd" clipRule="evenodd" d="M19.185 3.61507C20.5422 3.75751 21.5999 4.90533 21.5999 6.3002V14.1002C21.5999 15.5914 20.3911 16.8002 18.8999 16.8002H16.1999V8.4002C16.1999 6.74334 14.8568 5.4002 13.1999 5.4002H9.75354C10.0938 4.43743 10.9647 3.72529 12.0148 3.61507C12.1572 2.25793 13.305 1.2002 14.6999 1.2002H16.4999C17.8948 1.2002 19.0426 2.25793 19.185 3.61507ZM13.7999 3.9002C13.7999 3.40314 14.2028 3.0002 14.6999 3.0002H16.4999C16.997 3.0002 17.3999 3.40314 17.3999 3.9002V4.2002H13.7999V3.9002Z" fill="currentColor" /><path fillRule="evenodd" clipRule="evenodd" d="M2.40002 8.4002C2.40002 7.73745 2.93728 7.20019 3.60002 7.20019H13.2C13.8628 7.20019 14.4 7.73745 14.4 8.4002V20.4002C14.4 21.0629 13.8628 21.6002 13.2 21.6002H3.60002C2.93728 21.6002 2.40002 21.0629 2.40002 20.4002V8.4002ZM4.80002 12.3002C4.80002 11.8031 5.20297 11.4002 5.70002 11.4002H11.1C11.5971 11.4002 12 11.8031 12 12.3002C12 12.7973 11.5971 13.2002 11.1 13.2002H5.70002C5.20297 13.2002 4.80002 12.7973 4.80002 12.3002ZM4.80002 16.5002C4.80002 16.0031 5.20297 15.6002 5.70002 15.6002H11.1C11.5971 15.6002 12 16.0031 12 16.5002C12 16.9972 11.5971 17.4002 11.1 17.4002H5.70002C5.20297 17.4002 4.80002 16.9972 4.80002 16.5002Z" fill="currentColor" /></g></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default ClipboardDocumentListIcon;